import React from "react";

const FoyerPrivacy = () => {
  return (
    <div
      style={{
        padding: "2rem",
        lineHeight: "1.6",
        fontFamily: "Arial, sans-serif",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h1>Foyer – Privacy Policy</h1>
      <p>Last updated: May 10, 2026</p>
      <p>
        Welcome to Foyer. This Privacy Policy explains how Atticus Labs, LLC
        ("we", "us", "our") collects, uses, and protects your information when
        you use the Foyer mobile and tablet application. By using Foyer, you
        agree to the practices described in this policy.
      </p>

      <h2>What Foyer Does</h2>
      <p>
        Foyer is a family hub application that aggregates calendar events, chores,
        shopping lists, and meal plans for households. It displays shared
        information on a dedicated wall display and on family members' personal
        devices.
      </p>

      <h2>Information We Collect</h2>

      <h3>Account Information</h3>
      <p>
        When you sign in with Google, we receive your name and email address via
        Google's OAuth service. This information is used solely to authenticate
        your identity and associate your account with your household.
      </p>

      <h3>Family Member Data</h3>
      <p>
        You may add family members (children, adults, guests) to your household
        by providing their names and assigning roles. This information is stored
        securely and is only visible to members of your household.
      </p>

      <h3>Calendar Data</h3>
      <p>
        You may connect external calendar feeds (such as Google Calendar or
        school calendars in ICS format). Foyer fetches and stores event data
        from these feeds — including event titles, dates, times, and
        descriptions — to display within your household. We do not share this
        data with third parties.
      </p>

      <h3>Household Content</h3>
      <p>
        Chores, shopping lists, meal plans, countdowns, and other content you
        create within Foyer are stored in your household's private data store
        and are not accessible outside your household.
      </p>

      <h3>Push Notification Tokens</h3>
      <p>
        If you enable push notifications, we store a device token provided by
        Expo's push notification service. This token is used only to deliver
        notifications to your device. We do not share device tokens with
        advertisers or unrelated third parties.
      </p>

      <h3>Location (Weather)</h3>
      <p>
        Foyer uses your device's IP address to estimate your general geographic
        location (city/region) for the purpose of displaying local weather on
        the wall display. This location estimate is not stored beyond a
        24-hour cache on your device and is not linked to your identity.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To authenticate you and connect you to your household</li>
        <li>To display calendar events, chores, lists, and meals within your household</li>
        <li>To send push notifications for household reminders and events</li>
        <li>To show local weather on the wall display</li>
        <li>To maintain and improve the Foyer service</li>
      </ul>

      <h2>Data Storage and Security</h2>
      <p>
        Your data is stored on Amazon Web Services (AWS) infrastructure,
        including DynamoDB (database) and AWS AppSync (API). Access is secured
        through Amazon Cognito authentication. All data is transmitted over
        encrypted HTTPS connections. Household data is logically isolated — no
        household can access another household's data.
      </p>

      <h2>Third-Party Services</h2>
      <p>We use the following third-party services to operate Foyer:</p>
      <ul>
        <li><strong>Google OAuth</strong> – for sign-in authentication</li>
        <li><strong>Amazon Web Services (AWS)</strong> – for data storage and API</li>
        <li><strong>Expo (Expo Application Services)</strong> – for app delivery and push notifications</li>
        <li><strong>ipapi.co</strong> – for IP-based location estimation (weather only)</li>
      </ul>
      <p>
        Each of these services has its own privacy policy and data handling
        practices. We do not sell, rent, or share your personal data with any
        advertising networks or data brokers.
      </p>

      <h2>Data Retention</h2>
      <p>
        Your household data is retained as long as your account is active. If
        you request deletion of your account, we will remove your personal
        information and household data within 30 days.
      </p>

      <h2>Children's Privacy</h2>
      <p>
        Foyer is designed for household use and may store names and roles of
        child family members as entered by a parent or guardian. We do not
        knowingly collect personal information directly from children under 13.
        Child family members do not need their own accounts — their information
        is managed by the household owner.
      </p>

      <h2>Your Rights</h2>
      <p>
        You have the right to access, correct, or request deletion of your
        personal information at any time. To exercise these rights, contact us
        at the address below.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you
        of significant changes by posting the updated policy here and updating
        the "Last updated" date above.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy or wish to request
        deletion of your data, please contact us at:{" "}
        <a href="mailto:tom@atticuslabs.net">tom@atticuslabs.net</a>
      </p>
    </div>
  );
};

export default FoyerPrivacy;
